export const SHOW_LOADER = "SHOW_LOADER"
export const HIDE_LOADER = "HIDE_LOADER"

export const setShowLoader = (data:any) => {
    return {
        type:SHOW_LOADER,
        payload:data
    }
}

export const setHideLoader = (data:any) => {
    return {
        type:HIDE_LOADER,
        payload:data
    }
}